// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuButton_menu__WTlM3","menuItem":"MenuButton_menuItem__2fsE7"};